import api from '../api';

function authHeaders(accessToken) {
    return {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
    };
}

export function isTruthyFlag(value) {
    return value === true || value === 1 || value === '1' || value === 'true';
}

export function pendingItemLabel(item) {
    if (item == null) return '';
    if (typeof item === 'string' || typeof item === 'number') return String(item);
    return item.title
        || item.name
        || item.lessonTitle
        || item.quizTitle
        || item.label
        || '';
}

export function normalizeEligibility(data) {
    const source = data && typeof data === 'object' ? data : {};
    const lessons = source.pendingLessons
        ?? source.lessonsPending
        ?? source.aulasPendentes
        ?? source.lessons
        ?? [];
    const quizzes = source.pendingQuizzes
        ?? source.quizzesPending
        ?? source.quizzesPendentes
        ?? source.quizzes
        ?? [];
    return {
        eligible: isTruthyFlag(source.eligible),
        issued: isTruthyFlag(source.issued),
        message: source.message || source.mensagem || '',
        pendingLessons: Array.isArray(lessons) ? lessons : [],
        pendingQuizzes: Array.isArray(quizzes) ? quizzes : [],
    };
}

export default {
    async getPortalCertificates(accessToken) {
        try {
            const response = await api.get('/portal/certificate', {
                headers: authHeaders(accessToken),
            });
            return response.data;
        } catch (error) {
            console.error('Error fetching portal certificates:', error);
            throw error;
        }
    },
    async getPortalCertificate(accessToken, courseId) {
        try {
            const response = await api.get(`/portal/certificate/${courseId}`, {
                headers: authHeaders(accessToken),
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao consultar o certificado do curso:', error);
            throw error;
        }
    },
    async getCertificateEligibility(accessToken, courseId) {
        try {
            const response = await api.get(`/portal/certificate/${courseId}/eligibility`, {
                headers: authHeaders(accessToken),
            });
            return normalizeEligibility(response.data);
        } catch (error) {
            console.error('Erro ao consultar elegibilidade do certificado:', error);
            throw error;
        }
    },
    async issueCertificate(accessToken, courseId) {
        try {
            const response = await api.post(`/portal/certificate/${courseId}`, {}, {
                headers: authHeaders(accessToken),
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao emitir o certificado:', error);
            throw error;
        }
    },
};
